var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1837 1.569C15.0988 1.26621 14.9335 0.992077 14.7052 0.775744C14.4706 0.55276 14.1829 0.393253 13.8695 0.312281C12.6965 0.00309732 7.99689 0.00309739 7.99689 0.00309739C6.03768 -0.0191934 4.07895 0.0788471 2.13176 0.296666C1.81833 0.38362 1.53124 0.54669 1.29603 0.771372C1.06492 0.993735 0.897526 1.26794 0.81008 1.56838C0.600018 2.70002 0.497955 3.84906 0.505268 5.00001C0.497773 6.14992 0.599585 7.29859 0.81008 8.43163C0.895652 8.73082 1.06242 9.00378 1.29416 9.22427C1.52589 9.44476 1.81446 9.60404 2.13176 9.68836C3.3204 9.99692 7.99689 9.99692 7.99689 9.99692C9.95859 10.0192 11.9198 9.9212 13.8695 9.70335C14.1829 9.62238 14.4706 9.46287 14.7052 9.23989C14.9334 9.0236 15.0985 8.74942 15.1831 8.44663C15.3986 7.31542 15.5034 6.16591 15.496 5.01437C15.5122 3.85797 15.4075 2.70303 15.1837 1.56838V1.569ZM6.50281 7.13868V2.86195L10.4129 5.00063L6.50281 7.13868Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8387c30c4a1801a4f69de6f1a01c8085.svg";
export { ForwardRef as ReactComponent };